// parseFloat("7,30") devolve 7: a virgula corta o decimal em silencio.
// numBR aceita os dois separadores e ignora espaco: "18, 5" vale 18,5.
// parseFloat("18. 5") para no espaco e devolve 18 — foi esse o bug.
export function numBR(v) {
  if (typeof v === "number") return v
  const n = parseFloat(String(v == null ? "" : v).replace(/\s/g, "").replace(",", "."))
  return isNaN(n) ? 0 : n
}

// Resultado realizado: o que as vendas ja consumaram. O P&L das posicoes mede so o
// que esta na carteira HOJE, entao quem vendeu no prejuizo nunca ve esse prejuizo
// em lugar nenhum. Custo medio a cada venda, que e a convencao da corretora.
// Depende do livro estar completo: com lancamento consolidado o numero sai pequeno
// demais e parece bom. Medido em 06/10/2026 na FBTC: com o livro antigo dava -$100,
// com o historico inteiro dava -$706, e a tela da Nomad dizia -$605,73 no total.
export function resultadoRealizado(txs) {
  const porSym = {}
  // realizado acumulado por data. O cabecalho do grafico precisa saber quanto foi
  // realizado DENTRO da janela, e para isso precisa da serie, nao do total.
  let _accReal = 0
  const _porData = []
  const ord = (txs || []).slice().sort(function (a, b) {
    const _d = String(a.traded_at || "").localeCompare(String(b.traded_at || ""))
    if (_d !== 0) return _d
    // dentro do mesmo dia, compra antes de venda. Ordenar so por data deixava
    // isso por conta do banco, que nao garante ordem nenhuma. Em 16/09/2026 a
    // GOOGL tem venda de 1.76291 e compra de 0.20198 no mesmo dia: com a venda
    // primeiro o Math.min cortava a baixa, o medio saia errado e o total do
    // cartao fechava $0.71 acima. Mesma causa do fantasma de $69.61 que inflava
    // o ultimo ponto do grafico. Compra antes de venda nao corta nada, e e a
    // ordem que reproduziu 97 de 98 conferencias contra os extratos.
    return (a.side === "sell" ? 1 : 0) - (b.side === "sell" ? 1 : 0)
  })
  for (const t of ord) {
    const sy = t.symbol
    if (!sy) continue
    if (!porSym[sy]) porSym[sy] = { q: 0, custo: 0, realizado: 0 }
    const o = porSym[sy]
    const q = Math.abs(numBR(t.quantity)), pr = numBR(t.price)
    if (t.side === "sell") {
      if (o.q <= 0.0000001) continue
      const usa = Math.min(q, o.q)
      const medio = o.custo / o.q
      o.realizado += usa * (pr - medio)
      _accReal += usa * (pr - medio)
      _porData.push({ d: String(t.traded_at || "").slice(0, 10), acc: _accReal })
      o.custo -= usa * medio
      o.q -= usa
    } else {
      o.q += q
      o.custo += q * pr
    }
  }
  let total = 0
  for (const k in porSym) total += porSym[k].realizado
  return { porSym: porSym, total: total, porData: _porData }
}
